export default {"src":"/_next/static/media/OMR.524216fb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};